import { c as _c } from "react/compiler-runtime";
import { AccountLockup, AccountLockupAvatar, useChains } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { useDateTimeFormatter } from "@opensea/i18n";
import { Avatar, Button } from "@opensea/next-ui-kit";
import { CenterAligned, classNames, FlexCenter, FlexColumn, Separator, SpaceBetween, TextBody, Tooltip } from "@opensea/ui-kit";
import { ArrowLeft, ArrowRight } from "@opensea/ui-kit/icons";
import { areCurrenciesEqual } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { NativePrice } from "@/components/price/NativePrice";
import { TokenPrice } from "@/components/price/TokenPrice";
import { UsdPrice } from "@/components/price/UsdPrice";
import { useAddress } from "@/hooks/wallet";
import { TokenSwapPrice } from "../TokenSwapActivityTable/cells/TokenSwapPrice";
import { TokenSwapRoute } from "../TokenSwapRoute";
import { useSwapProtocols } from "../use-swap-protocols";
import { TokenSwapActivityAnnotationFragment } from "./TokenSwapActivityAnnotation.fragment";
export function TokenSwapActivityAnnotation(t0) {
  const $ = _c(99);
  const {
    activities: activityKeys,
    contract
  } = t0;
  const t = useTranslations("TokenSwapActivityAnnotation");
  const activities = activityKeys.map(_temp);
  const connectedAddress = useAddress();
  const formatDate = useDateTimeFormatter();
  const {
    getChain
  } = useChains();
  const tokenChain = getChain(contract.chain);
  const nativeSymbol = tokenChain?.nativeCurrency?.symbol;
  const {
    getLogo
  } = useSwapProtocols();
  const [activityIndex, setActivityIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const activity = activities[activityIndex];
  const relevantToken = [activity.fromToken, activity.toToken].find(token => token.token.address === contract.address && token.token.chain.identifier === contract.chain);
  const type = areCurrenciesEqual({
    contractAddress: activity.fromToken.token.address,
    chainIdentifier: activity.fromToken.token.chain.identifier
  }, {
    contractAddress: contract.address,
    chainIdentifier: contract.chain
  }) ? "sell" : "buy";
  if (!relevantToken) {
    return null;
  }
  const T0 = Tooltip;
  const T1 = FlexColumn;
  const t1 = "min-w-[240px] gap-3 px-1 py-2";
  const t2 = activity.swapProtocol && <Avatar size={32} {...getLogo(activity.swapProtocol.identifier)} />;
  let t3;
  if ($[0] !== t || $[1] !== type) {
    t3 = type === "buy" ? t("buy") : t("sell");
    $[0] = t;
    $[1] = type;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <TextBody>{t3}</TextBody>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <FlexCenter className="gap-3">{t2}{t4}</FlexCenter>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = activities.length > 1 && <FlexCenter className="gap-2"><Button disabled={activityIndex === 0} icon={ArrowLeft} onClick={() => setActivityIndex(activityIndex - 1)} size="sm" variant="secondary" /><TextBody>{t("activityCount", {
        count: activityIndex + 1,
        total: activities.length
      })}</TextBody><Button disabled={activityIndex === activities.length - 1} icon={ArrowRight} onClick={() => setActivityIndex(activityIndex + 1)} size="sm" variant="secondary" /></FlexCenter>;
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <SpaceBetween className="justify-between">{t5}{t6}</SpaceBetween>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Separator />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== activity) {
    t9 = <TextBody color="text-secondary" size="sm"><TokenSwapRoute activity={activity} /></TextBody>;
    $[12] = activity;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const T2 = FlexColumn;
  const t10 = "gap-1";
  let t11;
  if ($[14] !== t) {
    t11 = t("price");
    $[14] = t;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = <TextBody color="text-secondary">{t11}:</TextBody>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== activity || $[19] !== type) {
    t13 = <TextBody weight="semibold"><TokenSwapPrice activity={activity} type={type} /></TextBody>;
    $[18] = activity;
    $[19] = type;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t12 || $[22] !== t13) {
    t14 = <FlexCenter className="gap-1">{t12}{t13}</FlexCenter>;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t) {
    t15 = t("amount");
    $[24] = t;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t15) {
    t16 = <TextBody color="text-secondary">{t15}:</TextBody>;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  const t17 = type === "buy" ? "success-1" : "error-1";
  let t18;
  if ($[28] !== relevantToken || $[29] !== t17) {
    t18 = <TextBody weight="semibold"><TokenPrice bounded={false} display="quantity" price={relevantToken} valueColor={t17} /></TextBody>;
    $[28] = relevantToken;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t16 || $[32] !== t18) {
    t19 = <FlexCenter className="gap-1">{t16}{t18}</FlexCenter>;
    $[31] = t16;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t) {
    t20 = t("totalUsd");
    $[34] = t;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t20) {
    t21 = <TextBody color="text-secondary">{t20}:</TextBody>;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  const t22 = type === "buy" ? "success-1" : "error-1";
  let t23;
  if ($[38] !== relevantToken) {
    t23 = <UsdPrice price={relevantToken} />;
    $[38] = relevantToken;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== t22 || $[41] !== t23) {
    t24 = <TextBody color={t22} weight="semibold">{t23}</TextBody>;
    $[40] = t22;
    $[41] = t23;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t21 || $[44] !== t24) {
    t25 = <FlexCenter className="gap-1">{t21}{t24}</FlexCenter>;
    $[43] = t21;
    $[44] = t24;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  const T3 = FlexCenter;
  const t26 = "gap-1";
  const T4 = TextBody;
  const t27 = "text-secondary";
  const t28 = t("totalNative", {
    symbol: nativeSymbol || ""
  });
  let t29;
  if ($[46] !== T4 || $[47] !== t28) {
    t29 = <T4 color={t27}>{t28}:</T4>;
    $[46] = T4;
    $[47] = t28;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  let t30;
  if ($[49] !== relevantToken) {
    t30 = <TextBody weight="semibold"><NativePrice currency="crypto" price={relevantToken} /></TextBody>;
    $[49] = relevantToken;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] !== T3 || $[52] !== t29 || $[53] !== t30) {
    t31 = <T3 className={t26}>{t29}{t30}</T3>;
    $[51] = T3;
    $[52] = t29;
    $[53] = t30;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  let t32;
  if ($[55] !== T2 || $[56] !== t14 || $[57] !== t19 || $[58] !== t25 || $[59] !== t31) {
    t32 = <T2 className={t10}>{t14}{t19}{t25}{t31}</T2>;
    $[55] = T2;
    $[56] = t14;
    $[57] = t19;
    $[58] = t25;
    $[59] = t31;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Separator />;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== activity.timestamp || $[63] !== formatDate) {
    t34 = formatDate(new Date(activity.timestamp), {
      display: "datetime"
    });
    $[62] = activity.timestamp;
    $[63] = formatDate;
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  let t35;
  if ($[65] !== t34) {
    t35 = <TextBody color="text-secondary">{t34}</TextBody>;
    $[65] = t34;
    $[66] = t35;
  } else {
    t35 = $[66];
  }
  let t36;
  if ($[67] !== T1 || $[68] !== t32 || $[69] !== t35 || $[70] !== t7 || $[71] !== t8 || $[72] !== t9) {
    t36 = <T1 className={t1}>{t7}{t8}{t9}{t32}{t33}{t35}</T1>;
    $[67] = T1;
    $[68] = t32;
    $[69] = t35;
    $[70] = t7;
    $[71] = t8;
    $[72] = t9;
    $[73] = t36;
  } else {
    t36 = $[73];
  }
  const t37 = type === "buy";
  const t38 = type === "sell";
  let t39;
  if ($[74] !== open || $[75] !== t37 || $[76] !== t38) {
    t39 = classNames("pointer-events-none absolute inset-0 rounded-full", {
      "animate-[ping_1500ms_ease-out_infinite]": open,
      "bg-success-1": t37,
      "bg-error-1": t38
    });
    $[74] = open;
    $[75] = t37;
    $[76] = t38;
    $[77] = t39;
  } else {
    t39 = $[77];
  }
  let t40;
  if ($[78] !== t39) {
    t40 = <span className={t39} />;
    $[78] = t39;
    $[79] = t40;
  } else {
    t40 = $[79];
  }
  let t41;
  if ($[80] !== open) {
    t41 = classNames("relative transition-transform duration-200", {
      "scale-105": open
    });
    $[80] = open;
    $[81] = t41;
  } else {
    t41 = $[81];
  }
  let t42;
  if ($[82] !== activities[0] || $[83] !== activities.length || $[84] !== connectedAddress || $[85] !== type) {
    t42 = activities.length === 1 ? <AccountLockup account={activities[0].sender} connectedAddress={connectedAddress ?? null} isLink={false}><AccountLockupAvatar size={20} /></AccountLockup> : <CenterAligned className={classNames("size-5 rounded-full bg-bg-primary", {
      "bg-success-2": type === "buy",
      "bg-error-2": type === "sell"
    })}><TextBody className="leading-5" size="sm" weight="semibold">{activities.length}</TextBody></CenterAligned>;
    $[82] = activities[0];
    $[83] = activities.length;
    $[84] = connectedAddress;
    $[85] = type;
    $[86] = t42;
  } else {
    t42 = $[86];
  }
  let t43;
  if ($[87] !== t41 || $[88] !== t42) {
    t43 = <div className={t41}>{t42}</div>;
    $[87] = t41;
    $[88] = t42;
    $[89] = t43;
  } else {
    t43 = $[89];
  }
  let t44;
  if ($[90] !== t40 || $[91] !== t43) {
    t44 = <CenterAligned className="relative size-[26px]">{t40}{t43}</CenterAligned>;
    $[90] = t40;
    $[91] = t43;
    $[92] = t44;
  } else {
    t44 = $[92];
  }
  let t45;
  if ($[93] !== T0 || $[94] !== open || $[95] !== setOpen || $[96] !== t36 || $[97] !== t44) {
    t45 = <T0 content={t36} onOpenChange={setOpen} open={open}>{t44}</T0>;
    $[93] = T0;
    $[94] = open;
    $[95] = setOpen;
    $[96] = t36;
    $[97] = t44;
    $[98] = t45;
  } else {
    t45 = $[98];
  }
  return t45;
}
function _temp(key) {
  return readFragment(TokenSwapActivityAnnotationFragment, key);
}